module.exports = __webpack_public_path__ + "img/icon-google.9e9448b3.svg";